export const SET_MAP_STATUS = "SET_MAP_STATUS";

export const SET_MAP_SELECTED_EVID = "SET_MAP_SELECTED_EVID";
export const CLEAR_MAP_SELECTED_EVID = "CLEAR_MAP_SELECTED_EVID";

export const SET_MAP_SELECTED_TRID = "SET_MAP_SELECTED_TRID";
export const CLEAR_MAP_SELECTED_TRID = "CLEAR_MAP_SELECTED_TRID";

export const SET_MAP_SELECTED_GEOID = "SET_MAP_SELECTED_GEOID";
export const CLEAR_MAP_SELECTED_GEOID = "CLEAR_MAP_SELECTED_GEOID";